import React from "react";
import { ButtonProps } from "antd";
import { useTranslate } from "@refinedev/core";
import { signInWithRedirect } from "aws-amplify/auth";
import { TrackedButton } from "components/TrackedButton";
import { AnalyticsEvents } from "types/analytics";
import { OauthFlowAction } from "types";
import { AppleFilled } from "@ant-design/icons";
import {
  clearPendingAuthMethod,
  setPendingAuthMethod,
} from "services/pendingAuthMethod";
import { serializeAttribution } from "utils/analytics";

export const AppleLoginButton: React.FC<
  ButtonProps & { action: OauthFlowAction }
> = ({ style, action, title, ...rest }) => {
  const t = useTranslate();

  const handleAppleLogin = async () => {
    try {
      clearPendingAuthMethod();
      setPendingAuthMethod("apple");
      await signInWithRedirect({
        provider: "Apple",
        customState: serializeAttribution(),
      });
    } catch (error) {
      console.error(
        t("pages.auth.errors.providerLoginError", { provider: "Apple" }),
        error
      );
    }
  };

  return (
    <TrackedButton
      trackingEventName={AnalyticsEvents.LoginAttempt}
      trackingProps={{ login_method: "apple", action }}
      type="default"
      icon={<AppleFilled style={{ fontSize: 24 }} />}
      onClick={handleAppleLogin}
      style={style}
      {...rest}
    >
      {title ?? t("pages.login.appleLogin")}
    </TrackedButton>
  );
};
